module.exports = __webpack_public_path__ + "img/horizontal_5_1_7016.0ea6b65b.png";